import type { IconProps } from '@src/components/icons/IconProps';

export function PaperPlaneIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="m21 3-7 18-4-7-7-4 18-7Z" />
      <path d="m10 14 11-11" />
    </svg>
  );
}
